export default class Literal {
  constructor() {
    this.codIdioma;
    this.texto;
  }
}
